import * as React from "react";
import { useTranslations } from "../../i18n/useTranslations";
import { useMenu } from "../../Menu/useMenu";
import { mapBooleanToOpenClose } from "../../utils";
import { CircleCloseButton } from "./CircleCloseButton";

export const MenuButton = () => {
	const { toggleMenu, isOpen } = useMenu();
	const { t } = useTranslations();

	return (
		<button
			tabIndex={0}
			data-track-label={`btn:menu:${mapBooleanToOpenClose(!isOpen)}`}
			className="focus:elm-outline-none elm-p-0 elm-border-0 elm-bg-transparent elm-w-10 elm-h-10 elm-rounded-full elm-overflow-hidden lg:hover:elm-bg-dd-blue-100 elm-pointer-events-auto elm-cursor-pointer"
			onClick={toggleMenu}
			title={t("Menu")}
			aria-label={t("Menu")}
		>
			{isOpen ? <CircleCloseButton /> : <RegularState />}
		</button>
	);
};

function RegularState() {
	return (
		<span className="elm-w-10 elm-h-10 elm-flex elm-justify-center elm-items-center elm-transition elm-pointer-events-none">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				height="24px"
				viewBox="0 0 24 24"
				width="24px"
				className="elm-block elm-fill-current elm-text-dd-blue-900"
			>
				<path d="M0 0h24v24H0z" fill="none" />
				<path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
			</svg>
		</span>
	);
}
